var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"w-full text-base-content"},[_c('div',[_vm._v(_vm._s(_vm.$t('pages.theme_admin.configuration')))]),_c('div',{staticClass:"flex justify-end mb-6"})])
}
var staticRenderFns = []

export { render, staticRenderFns }